import axios from 'axios';
import Cookies from 'js-cookie';

import type { EventTypeEnum } from './type';
import { getCookieId } from './util';

export const useTrack = () => {
  const track = (
    functionId: string,
    eventType: EventTypeEnum,
    utlogMap?: object,
  ) => {
    if (process.env.VUE_APP_TRACK_ENABLED != 'true') {
      return;
    } 

    const userInfo = Cookies.get('userInfo');
    let userId = 'guest';

    if (userInfo) {
      userId = JSON.parse(userInfo).id;
    }

    axios({
      method: 'POST',
      url: process.env.VUE_APP_TRACK_SERVER,
      data: {
        functionId,
        eventType,
        userId,
        cookieId: getCookieId(),
        uuid: localStorage.getItem('uuid'),
        clientType: 'pc',
        lang: localStorage.getItem('locale') || 'en-US',
        url: document.location.href,
        preUrl: document.referrer ? document.referrer : '直接访问',
        channel: process.env.VUE_APP_TRACK_CHANNEL,
        utlogMap: JSON.stringify(utlogMap),
      },
      headers: {
        'Content-Type': 'application/json',
        'dde-ananlytics-utlog-api-key': Cookies.get('apiKey'),
      },
    });
  };

  return {
    track,
  };
};
